











































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

import ModalTabs from "../../DashboardLayoutComponents/ModalTabs.vue";
import FormField from "../../DashboardLayoutComponents/FormField.vue";

import userModel from "@/models/user.model";
import specialtyModel from "@/models/specialty.model";
import sectorModel from "@/models/sector.model";
import professionModel from "@/models/profession.model";
import { FooterExtraButtonProps } from "@/layouts/DashboardLayoutComponents/ModalTabs.vue";

@Component({
	components: { ModalTabs, FormField },
})
export default class UserModal extends Vue {
	tabs = [
		{ icon: 'edit', name: 'Dados' },
		{ icon: 'phone', name: 'Contato' },
		{ icon: 'work', name: 'Profissional' },
		{ icon: 'attach_money', name: 'Financeiro' },
		{ icon: 'screen_lock_portrait', name: 'Acesso aplicativo' },
		{ icon: 'delete', name: 'Excluir' },
	];
	footerExtraButtons: FooterExtraButtonProps[] = []
	schema = [];
	entity: any = { userSectors: []	};
	serverEntityJson: string = '';
	loading = false;
	error = "";
	sectorModel: any;
	specialtyModel: any;
	professionModel: any;

	constructor() {
		super();
		this.specialtyModel = specialtyModel;
		this.sectorModel = sectorModel;
		this.professionModel = professionModel;
		this.footerExtraButtons = [
			{ actionText: 'Aprovar cadastro', class: 'md-sm md-success', onClick: this.handleProfessionalApprovedClick },
		]
	}

	@Prop({ required: true })
	private userId: any;

	private async mounted() {
		this.loading = true;
		try {
			this.schema = await userModel.getDescription();
			await this.readEntity(this.userId);
		} catch (error) {
			console.error(error);
		}
		this.loading = false;
	}

	async handleProfessionalApprovedClick() {
		const { id } = this.$route.params

		if (id) {
			try {
				await userModel.approveProfessionalRegistration(Number(id))
				this.$toasted.success('Cadastro profissional aprovado');
				this.$emit('close');
			} catch (error) {
				console.error('DEBUGG: Erro ao aprovar cadastro profissional', error)
				this.$toasted.error('Não foi possível aprovar o cadastro deste profissional. Tente novamente.');
				(this.$refs.modalTabs as ModalTabs).actionCompleted();
			}
		}
	}

	updateNotes(notes: string) {
		this.entity.auditNotes = notes;
	}

	private async readEntity(id: number) {
		this.entity = Object.assign(await userModel.read(id), { userSectors: (await userModel.read(id, "userSectors")).userSectors });
		this.serverEntityJson = JSON.stringify(Object.assign({}, this.entity)); // copy entity to compare before update
	}

	private async updateUser() {
		// check password confirmation
		if (this.entity.password && this.entity.password !== this.entity.passwordConfirmation) {
			this.$toasted.error('Verifique a confirmação da senha');
			return;
		}
		try {
			await userModel.update(this.entity.id, this.entity);
			await this.readEntity(this.entity.id);
			this.$toasted.success('Usuário atualizado');
			(this.$refs.modalTabs as ModalTabs).clearNotes();
		} catch (error) {
			console.error(error);
			this.$toasted.error(error.friendlyMessage || 'Não foi possível atualizar. Tente novamente.');
		}
		(this.$refs.modalTabs as ModalTabs).actionCompleted();
	}

	private async deleteUser() {
		if (!this.entity.deletionReason) {
			this.$toasted.error('Selecione uma justificativa para exclusão');
			(this.$refs.modalTabs as ModalTabs).actionCompleted();
			return;
		}

		try {
			await userModel.delete(this.entity.id, `Justificativa: ${this.entity.deletionReason}\n${this.entity.auditNotes || ''}`);
			this.$toasted.success('Usuário excluído');
			this.$emit('close');
		} catch (error) {
			this.$toasted.error('Não foi possível excluir o usuário. Tente novamente.');
			(this.$refs.modalTabs as ModalTabs).actionCompleted();
		}
	}

	get enableAction() {
		return  JSON.stringify(Object.assign({}, this.entity)) !== this.serverEntityJson;
	}

	getField(key: string) {
		return this.schema.find((prop: any) => prop.key === key) || {};
	}
}
